import axios from "axios";
import { envUrls } from "../baseUrl";

let headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
};
export const instance = axios.create({
    baseURL: envUrls?.apiUrl,
    headers: headers,
});

export async function postRequest(requestUrl: string, data: any) {
    try {
        const token = localStorage.getItem("token");
        const response = await instance.post(requestUrl, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error: any) {
        if (error?.response?.data?.message === "Invalid or expired token" || error?.response?.data?.message === "Session not found. Please log in again." || error?.status === 401) {
            const keysToKeep = ["googleToken", "name", "email", "picture"];
            const preservedValues: Record<string, string | null> = {};
            keysToKeep.forEach((key) => {
                const value = localStorage.getItem(key);
                if (value !== null) {
                    preservedValues[key] = value;
                }
            });
            localStorage.clear();
            Object.keys(preservedValues).forEach((key) => {
                const value = preservedValues[key];
                if (value !== null) {
                    localStorage.setItem(key, value);
                }
            });
            window.location.reload();
        }
        return error;
    }
}
export async function postRequestwithoutData(requestUrl: string, data: any) {
    try {
        const token = localStorage.getItem("token");
        const response = await instance.post(requestUrl, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response;

    } catch (error: any) {
        if (error?.response?.data?.message === "Invalid or expired token" || error?.response?.data?.message === "Session not found. Please log in again." || error?.status === 401) {
            const keysToKeep = ["googleToken", "name", "email", "picture"];
            const preservedValues: Record<string, string | null> = {};
            keysToKeep.forEach((key) => {
                const value = localStorage.getItem(key);
                if (value !== null) {
                    preservedValues[key] = value;
                }
            });
            localStorage.clear();
            Object.keys(preservedValues).forEach((key) => {
                const value = preservedValues[key];
                if (value !== null) {
                    localStorage.setItem(key, value);
                }
            });
            window.location.reload();
        }
        return error;
    }
}


export async function getRequest(requestUrl: string) {
    try {
        const token = localStorage.getItem("token");
        const response = await instance.get(requestUrl, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error: any) {
        if (error?.response?.data?.message === "Invalid or expired token" || error?.response?.data?.message === "Session not found. Please log in again." || error?.status === 401) {
            const keysToKeep = ["googleToken", "name", "email", "picture"];
            const preservedValues: Record<string, string | null> = {};
            keysToKeep.forEach((key) => {
                const value = localStorage.getItem(key);
                if (value !== null) {
                    preservedValues[key] = value;
                }
            });
            localStorage.clear();
            Object.keys(preservedValues).forEach((key) => {
                const value = preservedValues[key];
                if (value !== null) {
                    localStorage.setItem(key, value);
                }
            });
            window.location.reload();
        }
        return error;
    }
}
